// extracted by mini-css-extract-plugin
export var actionButton = "_kr-0";
export var fileInput = "_kr-2";
export var paperclip = "_kr-1";